export default "__VITE_ASSET__0d3e8b8e__"